export default __webpack_public_path__ + "static/media/login.21f13259.jpg";